package com.patronat.top.dto

import kotlinx.serialization.Serializable

@Serializable
data class ServerErrorResponse(
    val message: String,
    val code: String,
    val status: Int
)
